module.exports = __webpack_public_path__ + "static/media/generated-message-edit.a0bd96ea.png";